module.exports = __webpack_public_path__ + "img/logo.e97a6ee8.svg";